import requests from "@/common/fetch";
import { Result, mockResponse } from "../common";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import * as I from "./interface";
import mockData from "./mock.json";

export const queryFcpaTimeRange = (
  params: I.QueryFcpaTimeRangeParams,
  isMock?: boolean
): Result<I.QueryFcpaTimeRangeResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/fcpa/time/range",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryFcpaTimeRangeResult);
};

/** 交易可查询的时间范围 */
export const brandGmvTime = (
  params: I.BrandGmvTimeParams
): Result<I.BrandGmvTimeResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_insight/brand/gmv/time",
      toUnderCase(params)
    )
  );
};

/** 品牌gmv构成,表格数据 */
export const brandGmvConstituteTable = (
  params: I.BrandGmvConstituteTableParams,
  isMock?: boolean
): Result<I.BrandGmvConstituteTableResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/brand_gmv_constitute_table",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.BrandGmvConstituteTableResult);
};

/** 商品人群画像 */
export const goodsInsightPersp = (
  params: I.GoodsInsightPerspParams,
  isMock?: boolean
): Result<I.InsightPerspResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/goods_insight/persp",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.InsightPerspResult);
};

/** 店铺人群画像 */
export const mallInsightPersp = (
  params: I.MallInsightPerspParams,
  isMock?: boolean
): Result<I.InsightPerspResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/mall_insight/persp",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.InsightPerspResult);
};

/** 人群数量 */
export const queryCrowdDistri = (
  params: I.QueryCrowdDistriParams,
  isMock?: boolean
): Result<I.QueryCrowdDistriResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/crowd/distri",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryCrowdDistriResult);
};

/** 透视分析 */
export const brandMallPerspAnaly = (
  params: I.BrandMallPerspAnalyParams,
  isMock?: boolean
): Result<I.BrandMallPerspAnalyResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/brand/mall/persp",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.BrandMallPerspAnalyResult);
};

/** 变化趋势 */
export const queryChangeTrend = (
  params: I.QueryChangeTrendParams,
  isMock?: boolean
): Result<I.QueryChangeTrendResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/change/trend",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryChangeTrendResult);
};

/** 人群流转 */
export const queryConsumerTrans = (
  params: I.QueryConsumerTransParams,
  isMock?: boolean
): Result<I.QueryConsumerTransResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/consumer/trans",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryConsumerTransResult);
};

/** 人群流转分析 */
export const transAnalysis = (
  params: I.TransAnalysisParam
): Result<I.TransAnalysisResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_insight/consumer/trans/analysis",
      toUnderCase(params)
    )
  );
};

/** 商品人群购买行为 */
export const goodsPortraPurchaseData = (
  params: I.GoodsPortraPurchaseDataParams
): Result<I.GoodsPortraPurchaseDataResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_insight/goods_insight/purchase",
      toUnderCase(params)
    )
  );
};

/** 商品画像默认商品 */
export const goodsInsightDefaultGoods = (
  params: I.GoodsInsightDefaultGoodsParams,
  isMock?: boolean
): Result<I.GoodsInsightDefaultGoodsResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/business_insight/goods_insight/default_goods",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.GoodsInsightDefaultGoodsResult);
};

/** 分店铺贡献数据 */
export const queryFcpaMallContribution = (
  params: I.QueryFcpaMallContributionParams
): Result<I.QueryFcpaMallContributionResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_insight/fcpa/mall/contribution",
      toUnderCase(params)
    )
  );
};

/** 店铺人群分店铺贡献数据 */
export const queryMallCrowdContribution = (
  params: I.QueryMallCrowdContributionParams
): Result<I.QueryMallCrowdContributionResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_insight/mall_insight/contribution",
      toUnderCase(params)
    )
  );
};

/** 店铺人群数量趋势 */
export const queryMallInsightCrowdTrend = (
  params: I.QueryMallInsightCrowdTrendParams
): Result<I.QueryMallInsightCrowdTrendResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_insight/mall_insight/crowd_trend",
      toUnderCase(params)
    )
  );
};

/** 店铺人群概览 */
export const queryMallInsightOverview = (
  params: I.QueryMallInsightOverviewParams
): Result<I.QueryMallInsightOverviewResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/business_insight/mall_insight/overview",
      toUnderCase(params)
    )
  );
};
